import { useEffect, useLayoutEffect, useRef } from "react"
import Screen from "../../components/Screen"
import "./Location.css"
import mapboxgl from "mapbox-gl/dist/mapbox-gl-csp"
import MapboxWorker from "worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker"
import "mapbox-gl/dist/mapbox-gl.css"
import squareIcon from "./images/square.svg"
import walkIcon from "./images/walk.svg"
import bikeIcon from "./images/bike.svg"
import transitIcon from "./images/transit.svg"
import categories from "./data"
import { io } from "socket.io-client"
import { useStore } from "../../components/ApartmentFinder/State/Store"
import { useHistory } from "react-router"

mapboxgl.workerClass = MapboxWorker

const Location = () => {
  const socket = useRef()
  const map = useRef()
  const markers = useRef([])
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const mapCategory = useStore(state => state.mapCategory)
  const selectedLocation = useStore(state => state.mapLocation)
  const selectedCategory = mapCategory
  const setSelectedCategory = useStore(state => state.setMapCategory)
  const setSelectedLocation = useStore(state => state.setMapLocation)

  const setMarkers = (activeCategory, activeLocation) => {
    /**
     * Remove all markers and then add the ones that match the current state.
     */

    for (let marker of markers.current) {
      marker.remove()
    }
    markers.current = []
    if (activeCategory) {
      for (let location of activeCategory.locations) {
        const div = document.createElement("div")
        const img = document.createElement("img")
        if (activeLocation && location.name === activeLocation.name) {
          // Can't use react components as it expects a DOM element.
          div.classList.add("marker-large")
          const markerTop = document.createElement("div")
          markerTop.classList.add("marker-top")

          const markerMid = document.createElement("div")
          markerMid.classList.add("marker-mid")

          const markerBottom = document.createElement("div")
          markerBottom.classList.add("marker-bottom")
          const topLeft = document.createElement("div")
          topLeft.classList.add("top-left")
          const topRight = document.createElement("div")
          topRight.classList.add("top-right")
          const bottomLeft = document.createElement("bottom-left")
          bottomLeft.classList.add("marker")
          const bottomRight = document.createElement("bottom-right")
          bottomRight.classList.add("bottom-right")

          const topSpan = document.createElement("span")
          const lineSpan = document.createElement("span")
          const middleSpan = document.createElement("span")
          const bottomSpan = document.createElement("span")

          div.appendChild(img)
          div.appendChild(markerTop)
          div.appendChild(markerMid)
          div.appendChild(markerBottom)

          markerMid.appendChild(lineSpan)

          markerTop.appendChild(topLeft)
          markerTop.appendChild(topRight)
          markerTop.appendChild(topSpan)

          markerBottom.appendChild(bottomLeft)
          markerBottom.appendChild(bottomRight)
          markerBottom.appendChild(middleSpan)

          markerBottom.appendChild(bottomSpan)
          img.src = activeCategory.largeIcon
          topSpan.innerText = activeLocation.name
          const fontSize =
            activeLocation.name.length > 30
              ? 15
              : activeLocation.name.length < 12
              ? 22
              : 20
          topSpan.style.fontSize = `${fontSize}px`

          lineSpan.style.fontSize = "12.5px"
          if (activeLocation.line) {
            lineSpan.innerHTML =
              // "Lines:" +
              activeLocation.line
                .map(
                  (l, i) =>
                    `<img style="height: 0px color: #BD6260" src=${process.env.PUBLIC_URL}/assets/images/trainicons/${activeLocation.line[i]}.jpg>`
                )
                .join("")
            // lineSpan.innerHTML = `Service : ${activeLocation.line}`
          }

          middleSpan.innerText = "Minutes from Coronation Sq"
          bottomSpan.innerHTML = `${
            activeLocation.distances[0] < 10 ? "&nbsp;" : ""
          }${
            activeLocation.distances[0]
          }<img style="height: 15px" src=${walkIcon}><br>`
          bottomSpan.innerHTML += `${
            activeLocation.distances[1] < 10 ? "&nbsp;" : ""
          }${
            activeLocation.distances[1]
          }<img  style="height: 15px" src=${bikeIcon}><br>`
          bottomSpan.innerHTML += `${
            activeLocation.distances[2] < 10 ? "&nbsp;" : ""
          }${
            activeLocation.distances[2]
          }<img   style="height: 15px " src=${transitIcon}>`
        } else {
          img.style.width = "40px"
          img.classList.add("marker-small")
          img.src = activeCategory.smallIcon
          div.appendChild(img)
        }
        div.style.cursor = "pointer"
        div.dataset.name = location.name
        div.addEventListener("click", () => {
          setSelectedLocation(location.name)
        })
        markers.current.push(
          new mapboxgl.Marker(div, { anchor: "bottom" })
            .setLngLat([...location.coordinates].reverse())
            .addTo(map.current)
        )
      }
    }
  }

  // ** ADD BUTTON TO ICON ** //

  const mapRef = useRef()
  const history = useHistory()

  useLayoutEffect(() => {
    const el = document.querySelector("#square")
  }, [])

  useEffect(() => {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoidm1pc3R1ZGlvIiwiYSI6ImNrc2lzcDFtYzBkMXMydm5jNGxxOXRncnEifQ.UxpGoxNNSkeTVIhflMc1zA"

    const center = [-0.0145, 51.56]

    const bounds = [
      [-1.2983, 51.0344],
      [0.7722, 52.082]
    ]

    map.current = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/vmistudio/cksk9buzk2kum18p8vv6gqqjh",
      center: center,
      zoom: 14,
      maxBounds: bounds,
      attributionControl: false
    })

    map.current.on("click", e => {
      /**
       * User has clicked somewhere on the map - disable any active markers.
       */

      if (e.originalEvent.target.tagName !== "IMG") {
        setSelectedLocation(null)
      }
      if (e.originalEvent.target.id === "square") {
        history.push("/explore")
      }
    })

    map.current.on("zoom", e => {
      const zoom = map.current.getZoom()
      const el = document.querySelector("#square")
      if (zoom < 14) {
        const zoomDiff = parseInt((14 - zoom) * 20)
        el.style.width = `${120 - zoomDiff}px`
      } else {
        el.style.width = `${120}px`
      }
    })

    if (role) {
      socket.current = io(url)
      if (role === "sender") {
        map.current.on("move", e => {
          socket.current.emit("map", {
            ...e.target.getCenter(),
            zoom: e.target.getZoom()
          })
        })
      }
      if (role === "recipient") {
        socket.current.on("map", data => {
          map.current.flyTo({
            center: [data.lng, data.lat],
            zoom: [data.zoom]
          })
        })
      }
    }

    const img = document.createElement("img")
    img.style.width = "120px"
    img.style.zIndex = "1"
    img.src = squareIcon
    img.id = "square"

    new mapboxgl.Marker(img).setLngLat(center).addTo(map.current)
  }, [role, url])

  useEffect(() => {
    /**
     * User has changed category, or clicked on a marker.
     */

    const activeCategory =
      categories.filter(c => c.name === selectedCategory)[0] || null
    const activeLocation = activeCategory
      ? activeCategory.locations.filter(l => l.name === selectedLocation)[0]
      : null
    setMarkers(activeCategory, activeLocation)
  }, [selectedCategory, selectedLocation])

  return (
    <Screen className="location">
      <div ref={mapRef} id="map" />
      <div className="categories">
        {categories.map(category => (
          <img
            key={category.name}
            src={category.icon}
            alt={category.name}
            className={`category ${
              category.name === selectedCategory ? "selected" : ""
            }`}
            onClick={() =>
              setSelectedCategory(
                selectedCategory === category.name ? null : category.name
              )
            }
          />
        ))}
      </div>
    </Screen>
  )
}

export default Location
